<template>
  <div>
    <header-image
      :headerContents="headerContents"
      :headerBackground="'about'"
    />
    <rare-about-our-story/>
    <rare-about-our-data/>
    <board-carousel/>
    <want-to-know-more/>
    <rare-awards/>
  </div>
</template>

<script>

import HeaderHeroImage from '../../components/header/HeaderHeroImage';
import RareWantToKnowMore from '../../components/commonSections/RareWantToKnowMore';

import RareHomeHeaderContents from './components/RareAboutHeaderContents';
import RareAboutOurStory from './components/RareAboutOurStory';
import RareAboutOurData from './components/RareAboutOurData';
import boardCarousel from '../../components/carousels/boardCarousel';
import RareAwards from '../../components/carousels/awardsCarousel';

export default {
  name: 'about',
  components: {
    'header-image': HeaderHeroImage,
    'want-to-know-more': RareWantToKnowMore,
    'rare-home-header-contents': RareHomeHeaderContents,
    'rare-about-our-story': RareAboutOurStory,
    'rare-about-our-data': RareAboutOurData,
    'board-carousel': boardCarousel,
    'rare-awards': RareAwards,
  },
  data() {
    return {
      headerContents: 'rare-about-header-contents',
    };
  },
  mounted() {
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/about/about.vue